import type {Auth} from 'src/typings';
import type {IWindowService} from 'angular';

declare global {
    interface Window {
        currentAuth: Auth;
    }
}

export default class CurrentAuthProvider {
    public static providerName = 'currentAuth';

    public readonly $get: (_: IWindowService) => Auth;

    /*@ngInject*/
    constructor(private $windowProvider: IWindowService) {
        this.$get = /*@ngInject*/ ($window: IWindowService) => $window.currentAuth;
    }

    public getCurrentAuth(): Auth {
        return this.$windowProvider.$get().currentAuth;
    }
}